
import { Component, namespace, Vue } from 'bits/vue'
import BaseSidebar from 'vuecomponents/base_sidebar.vue'
import FeaturesContent from 'vuecomponents/features_content.vue'
import FeaturesNavigation from 'vuecomponents/features_navigation.vue'
import MembershipFooter from 'vuecomponents/membership_footer.vue'
import DarkModeMixin from 'vuemixins/dark_mode_mixin'
import WindowSizeMixin from 'vuemixins/window_size_mixin'

const browser = namespace('browser')

@Component({
  components: {
    BaseSidebar,
    FeaturesContent,
    FeaturesNavigation,
    MembershipFooter,
  },
  mixins: [DarkModeMixin, WindowSizeMixin],
})
export default class FeaturesApp extends Vue {
  @browser.Getter isPhone
  @browser.Getter isBiggerThanTabletLandscape

  get productClass(): object {
    return {
      'container-mobile': this.isPhone,
      container: true,
    }
  }
}
